import React, { useState, useEffect } from 'react'
import { GetAllRefrence, getDistinctEmployees, DeleteRefrneceById } from './ActionCreator'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import Pagination from '@mui/material/Pagination';
import Nodataimage from '../../../../../../images/nodata.png'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CheckFunction } from '../../../../../../layouts/MainTenantconfig';
import { Company_DATA } from '../../../../../../layouts/MainTenantconfig';
import moment from 'moment';
import Popup from '../../../../../presentationals/Popup/Popup.component'


export default function List({ handleTab }) {
    const tenant = CheckFunction()
    const [loader, setLoader] = useState(false);
    const [popup, setPopup] = useState({show:false,popupStatus:""});
    const [searchValue, setSearchValue] = useState("");
    const [listApiData, setListApiData] = useState([])
    const [listData, setListData] = useState([])
    const [listEmployees, setListEmployees] = useState([])

    useEffect(() => {
        GetAllRefrenceFromAPI()
        getDistinctEmployeesFn()
    }, [])

    const GetAllRefrenceFromAPI = () => {
        setLoader(true)
        GetAllRefrence(callback => {
            setLoader(false)
            console.log(callback)
            setListApiData(callback?.data)
            setListData(callback?.data)

        })
    }
    const getDistinctEmployeesFn = () => {
        setLoader(true)
        getDistinctEmployees(callback => {
            setLoader(false)
            console.log(callback)
            setListEmployees(callback?.data)

        })
    }



    const handleSearch = () => {
        if (searchValue !== "" && searchValue?.length > 0) {
            const data = Object.keys(listApiData)?.filter((el) => el == searchValue)
            console.log("data", listApiData[data])
            const obj = {
                [data]: listApiData[data]
            }
            setListData(obj)
        } else {
            setListData(listApiData)
        }
    }

    const handleDelete = (data) => {
        setLoader(true)
        DeleteRefrneceById(data?.id, callback => {
            setLoader(false)
             GetAllRefrenceFromAPI()
        getDistinctEmployeesFn()
            if(callback?.message == "success" && callback?.status == 200){
                setPopup({show:true,popupStatus:"Data Deleted Successfully"})
            }else{
                setPopup({show:true,popupStatus:"Error Deleting Data"})
            }
            removePopup()
        })
    }
    
    const closePopup =()=>{
        setPopup({show:false,popupStatus:""})
    }

    const removePopup = ()=>{
        setTimeout(()=>{
            closePopup()
        },5000)
    }


    return (
        <>
            {
                loader ? <Loader /> : ''
            }
            {
                popup?.show ? <Popup closePopup={closePopup} popupStatus={popup?.popupStatus} /> : ''
            }
            <div className="row" style={{ marginTop: '20px' }}>
                <div className="col-sm-2 col-xs-6">
                    <label htmlFor=""><i className='fa fa-search'></i> &nbsp;Employee Name</label>
                    <select className='form-control' value={searchValue} onChange={(e) => setSearchValue(e.target.value)} >
                        <option value="">Select Employee</option>
                        {
                            listEmployees?.length > 0 ? listEmployees?.map(v => (
                                <option value={v}>{v}</option>
                            ))
                                : ""}
                    </select>
                </div>
                <div className="col-sm-2 col-xs-6">
                    <div style={{ display: 'flex', gap: '20px', marginTop: '22px' }}>
                        <button className='btn-primary' style={{ padding: '10px 20px', borderRadius: '6px' }} onClick={() => handleSearch()}><i className='fa fa-search'></i></button>
                        <button className='btn-primary' style={{ padding: '10px 20px', borderRadius: '6px' }} onClick={() => handleTab("add", {})}><i className='fa fa-plus'></i></button>
                    </div>
                </div>
            </div>

            <hr />

            {
                listData && Object.keys(listData)?.length > 0 ?
                    Object.entries(listData)?.map(([key, value], id) => {
                        return (
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                    style={{ borderBottom: '2px solid #fff', background: tenant?.COMPANY_NAME == Company_DATA?.CREDFIN ? 'rgba(0, 108, 103, 0.2)' : "rgba(14, 87, 104, 0.5)" }}
                                >
                                    <Typography component="span" style={{ fontSize: '16px' }}>
                                        <b> {key}</b>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ height: 'auto', border: tenant?.COMPANY_NAME == Company_DATA?.CREDFIN ? '10px solid rgba(0, 108, 103, 0.2)' : "10px solid rgba(14, 87, 104, 0.5)", padding: '16px' }}>
                                    <div>
                                        <div className="overflow-auto">
                                            <table className="phocket-table">
                                                <thead>
                                                    <tr>
                                                        <th style={{ minWidth: '150px' }}>Details</th>
                                                        <th style={{ minWidth: '150px' }}>Employee Name</th>
                                                        <th style={{ minWidth: '150px' }}>Reference Code</th>
                                                        <th style={{ minWidth: '150px' }}>Created At</th>
                                                        <th style={{ minWidth: '150px' }}>Created At</th>
                                                        <th style={{ minWidth: '150px' }}>Status</th>
                                                        <th style={{ minWidth: '150px' }}>Edit</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        value && value?.length > 0 ?
                                                            value?.map((data, id) => {
                                                                return (
                                                                    <tr>
                                                                        <td style={{ padding: '15px' }}><i className='fa fa-info' style={{ cursor: 'pointer' }} onClick={() => handleTab("view", data)}></i></td>
                                                                        <td style={{ padding: '15px' }}>{data?.employeeName || "-"}</td>
                                                                        <td style={{ padding: '15px' }}>{data?.referenceCode || "-"}</td>
                                                                        <td style={{ padding: '15px' }}>{moment(data?.createdAt).format("DD-MM-YYYY") || "-"}</td>
                                                                        <td style={{ padding: '15px' }}>{data?.createdBy || "-"}</td>
                                                                        <td style={{ padding: '15px' }}>{data?.status == true ? "Yes" : "No" || "-"}</td>
                                                                        <td style={{ padding: '15px' }}><i className='fa fa-trash' style={{ cursor: 'pointer' }} onClick={() => handleDelete(data)}></i></td>

                                                                    </tr>
                                                                )
                                                            })
                                                            : ''}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                </AccordionDetails>
                            </Accordion>
                        )
                    })
                    : <div className='text-center'><img src={Nodataimage} style={{ width: '30%', marginTop: '4%' }} /></div>}
        </>
    )
}
